import { Checkbox, DatePicker, Form, Input, message, Modal, Spin } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { strDate2Server } from "@/extensions/utils";
import { serverFetch } from "@/server";

const ReestrZag = ({ id, onClose }) => {
  const [form] = Form.useForm();
  const [reestr, setReestr] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) return;

    setLoading(true);
    serverFetch(`Reestr/${id}`)
      .then(data => {
        setReestr(data);
        form.setFieldsValue({
          docDate: dayjs(data.docDate),
          paymentDate: data.paymentDate ? dayjs(data.paymentDate) : null,
          active: data.active,
          comment: data.comment,
        });
      })
      .catch(e => {
        message.error(e.userMessage);
        onClose(false);
      })
      .finally(() => setLoading(false));
  }, [id, form, onClose]);

  const onSave = () => {
    form.validateFields()
      .then(values => {
        const bodyData = {
          ...reestr,
          docDate: strDate2Server(values.docDate),
          paymentDate: values.paymentDate ? strDate2Server(values.paymentDate) : null,
          active: values.active,
          comment: values.comment,
        };
        serverFetch("Reestr", { method: "PUT", bodyData })
          .then(() => {
            message.success("Реестр сохранен");
            onClose(true);
          })
          .catch(e => message.error(e.userMessage));
      });
  };

  return (
    <Modal title="Редактирование реестра" open={!!id} onOk={onSave} onCancel={() => onClose(false)} okText="Сохранить" cancelText="Отмена">
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Form.Item label="Дата" name="docDate" rules={[{ required: true, message: "Укажите дату" }]}>
            <DatePicker format="DD.MM.YYYY" allowClear={false} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Дата оплаты" name="paymentDate">
            <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Активен" name="active" valuePropName="checked">
            <Checkbox />
          </Form.Item>
          <Form.Item label="Комментарий" name="comment">
            <Input maxLength={255} />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default ReestrZag;
